<template>
  <UiFilterItem
    v-slot="{ active }"
    v-model="value"
    :true-value="2"
    :false-value="1"
  >
    <UiIcon
      :name="active ? 'one-column' : 'grid'"
      class="size-6"
      :aria-label="active ? 'one-column' : 'grid'"
    />
  </UiFilterItem>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: number;
}>();
const emit = defineEmits(["update:modelValue"]);

const value = useVModel(props, "modelValue", emit);
</script>
